import * as React from 'react';
import { ReactNode, Fragment } from 'react';
import Amount from './Amount';
import '../css/breakdown.sass';

export interface BreakDownDetails {
  name: string;
  amount: number;
  color?: 'green' | 'yellow' | 'blue';
}

export interface BreakDownHeader {
  name: string;
  amount: string;
}

export interface BreakDownPriceSectionType {
  header: BreakDownHeader;
  details?: BreakDownDetails[];
}

export interface BreakdownProps {
  title?: string;
  startDate: string;
  endDate: string;
  summaryText?: ReactNode;
  priceSections: BreakDownPriceSectionType[];
  total: number;
  totalLabel?: string;
}

export default function Breakdown(props: BreakdownProps) {
  return (
    <>
      <div className="breakdown">
        <h2 className="title">{props.title || 'Breakdown'}</h2>
        <div className="date-header">
          {props.startDate} - {props.endDate}
        </div>
        {props.summaryText && (
          <div className="summaryText">{props.summaryText}</div>
        )}
        {props.priceSections.map(price => {
          return (
            <Fragment key={price.header.name}>
              <div className="br-details">
                {price.header.name}
                <div className="amount bold">
                  <Amount amount={price.header.amount} />
                </div>
              </div>
              {price.details &&
                price.details.map(subDetail => {
                  return (
                    <div
                      className={`subDetails ${
                        subDetail.color !== undefined
                          ? subDetail.color.toLowerCase()
                          : ''
                      }`}
                      key={subDetail.name}
                    >
                      <div>{subDetail.name}</div>
                      <div className="amount ml-auto">
                        <Amount amount={subDetail.amount} />
                      </div>
                    </div>
                  );
                })}
            </Fragment>
          );
        })}
        <div className="divider"></div>
        <div className="totalLabel">
          <span>{props.totalLabel || 'Transition Bill Total'}</span>
          <div className="amount bold">
            <Amount amount={props.total} />
          </div>
        </div>
      </div>
    </>
  );
}
